module.exports = __webpack_public_path__ + "static/media/aer.f7a9d139.png";